/**
 * @generated SignedSource<<47e9d93ddd8baf27ff03a12f66af41b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "globalVariable"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "globalVariable",
        "variableName": "globalVariable"
      }
    ],
    "concreteType": "GlobalVariableMutationResponse",
    "kind": "LinkedField",
    "name": "createGlobalVariable",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "globalVariableId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateGlobalVariableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateGlobalVariableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6d8164154b7e39066762318056260b49",
    "id": null,
    "metadata": {},
    "name": "CreateGlobalVariableMutation",
    "operationKind": "mutation",
    "text": "mutation CreateGlobalVariableMutation(\n  $globalVariable: GlobalVariableInput!\n) {\n  createGlobalVariable(globalVariable: $globalVariable) {\n    ok\n    error\n    globalVariableId\n    name\n  }\n}\n"
  }
};
})();

node.hash = "0348c2321b426dc86be0059e4ea7d34d";

export default node;
